import React from "react";
// import { RouteComponentProps, withRouter } from "react-router-dom";
import Admin from "us.collection.admin";
import { WithFeatureFlag } from "us.common/components";
import { FeatureFlags } from "us.common/constants";
import { withRouter } from "us.common/wIthRouter";

// interface ICntNonProductionDaysHome extends RouteComponentProps {}
interface ICntNonProductionDaysHome {}

const Cnt_NonProductionDaysHome: React.FC<ICntNonProductionDaysHome> = (
  props
) => {
  return (
    <WithFeatureFlag
      flag={FeatureFlags.NON_PRODUCTION_DAYS}
      children={
        <Admin.Components.NonProductionDays.NonProductionDaysHome {...props} />
      }
    />
  );
};

export default withRouter(Cnt_NonProductionDaysHome);
